module.exports = __webpack_public_path__ + "static/media/dollar-user-icon.26d89731.png";